module.exports = __webpack_public_path__ + "static/media/flag-no.576a01cf.webp";